import _ from 'underscore';

class Tabs {
  constructor() {
    this.selector = '.rpm-menu a.item';

    if ($(this.selector).length === 0) {
      return;
    }
    this.listen();
    this.setup();
  }

  listen() {
    $(document)
      .off('click.fndtn', '.rpm-menu a.item')
      .on('click.fndtn', '.rpm-menu a.item', (e) => {
        this.activate($(e.target), !$(e.target).hasClass('noHash'));
      });

    window.onhashchange = () => {
      if (_.isEmpty(window.location.hash)) {
        this.activate($(`${this.selector}:eq(0)`), false);
      } else {
        this.refresh();
      }
    };
  }

  getStorageKey() {
    return (
      'tabs' +
      ($('select.customer-change-select :selected').text() || '') +
      window.location.hostname +
      window.location.pathname
    );
  }

  refresh() {
    $('a[data-tab="' + window.location.hash.replace('#', '') + '"]').trigger(
      'click',
    );
  }

  activate($tab, changeHash = true) {
    var target = $tab.data('tab'),
      storedHash = localStorage.getItem(this.getStorageKey() || '');

    if (storedHash !== target) {
      localStorage.setItem(this.getStorageKey(), target);
    }

    if (changeHash) {
      window.location.hash = target;
    } else {
      localStorage.setItem(this.getStorageKey(), '');
      window.location.hash = '';
    }
    $tab.trigger('tabChange');
  }

  setup() {
    var hash;

    $(this.selector).tab();
    if (window.location.hash) {
      this.refresh();
    }

    hash = localStorage.getItem(this.getStorageKey());
    if (hash && hash !== 'undefined' && !_.isEmpty(hash)) {
      window.location.hash = hash;
      return;
    }

    $(`${this.selector}:eq(0)`)
      .addClass('noHash')
      .trigger('click')
      .removeClass('noHash');
  }
}

module.exports = Tabs;
